import axios from 'axios';
import { useSetRecoilState } from 'recoil';
import useApiClient from '~/src/hooks/useApiClient';
import { driftDetectionResultState } from '../store';

const useDriftDetectionAnalysis = () => {
  // Hooks
  const apiClient = useApiClient();

  // Recoil State
  const setDriftDetectionResult = useSetRecoilState(driftDetectionResultState);

  const getDriftDetectionFile = async (projectId: number) => {
    try {
      setDriftDetectionResult((prev) => ({ ...prev, isPending: true }));
      const { data: url } = await apiClient.get(`/projects/${projectId}/urls`, {
        params: { file: 'drift/drift_report.json' },
      });
      const { data } = await axios.get(url);

      let driftCols;

      if (data?.overall_drift_detected) {
        if (Object.keys(data?.columns)?.length > 0) {
          driftCols = Object.keys(data?.columns || {});
          driftCols = driftCols
            ?.filter((key) => data?.columns?.[key]?.drifted)
            ?.map((key) => ({ column: key, ...data?.columns?.[key] || {} }));
        } else {
          driftCols = [];
        }
      } else {
        driftCols = [];
      }
      setDriftDetectionResult((prev) => ({ ...prev, data: driftCols, isResultFetched: true }));
    } catch {
      setDriftDetectionResult((prev) => ({ ...prev, isResultFetched: true }));
    } finally {
      setDriftDetectionResult((prev) => ({ ...prev, isPending: false }));
    }
  };

  return { getDriftDetectionFile };
};

export default useDriftDetectionAnalysis;
